module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/settings/word-cloud-settings/word-cloud-settings.component.less
// module id = ./src/app/routes/settings/word-cloud-settings/word-cloud-settings.component.less
// module chunks = main